export default __webpack_public_path__ + "static/media/ig-gradient-plan-pack-growth.afc133a4.webp";